import React from 'react';
import { BannerContent, BannerHeader, BannerMedia, Banner, Typography } from 'common/components';
import {
  kitchenBannerContent,
  kitchenBannerTitleWrapper,
  kitchenBannerSubTitle,
} from './kitchen-project-banner-styles';

const KITCHEN_BANNER_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/kitchen-collections/main-page/kitchen-banner/';

const KITCHEN_PROJECT_LINK = '/proekt-kuhni/';

export const KitchenProjectBanner: React.FC = () => (
  <Banner
    bgColor="#819675"
    elementBlock="komplekty / catalogue"
    link={{
      href: KITCHEN_PROJECT_LINK,
      title: 'Записаться на проектирование кухни',
    }}
    promotion={{
      name: 'komplekty / catalogue_middle',
      creative: 'Не нашли подходящий дизайн',
      position: '1',
    }}>
    <BannerMedia
      alt="Проектирование кухни с помощью консультанта"
      srcD={`${KITCHEN_BANNER_CDN_PATH}banner-desktop.png/banner-desktop-01.png`}
      srcT={`${KITCHEN_BANNER_CDN_PATH}banner-tablet.png/banner-tablet-01.png`}
      src={`${KITCHEN_BANNER_CDN_PATH}banner-mobile.png/banner-mobile-01.png`}
    />
    <BannerContent className={kitchenBannerContent}>
      <BannerHeader className={kitchenBannerTitleWrapper} title="Не&nbsp;нашли подходящий дизайн?" />
      <Typography className={kitchenBannerSubTitle} variant="m" size="body_long" color="text-invert">
        Спроектируйте свою идеальную кухню самостоятельно
      </Typography>
    </BannerContent>
  </Banner>
);
